
import React, { forwardRef } from 'react'

import './InputDropdownToggle.scss'

interface Props {
  children: any
  disabled?: boolean
  onClick: (e: any) => void
}

const InputDropdownToggle = forwardRef(({ children, disabled, onClick }: Props, ref: any) => {

  return (
    <div
      ref={ref}
      className='input-dropdown-toggle'
      onClick={(e) => {
        e.preventDefault();

        if (disabled) return;
        onClick(e);
      }}
    >
      {children}
    </div>
  )
})

InputDropdownToggle.displayName = 'InputDropdownToggle'

export default InputDropdownToggle
